// src/components/TopBar.js
import React from "react";

function TopBar() {
  return null;
}

export default TopBar;
